import { Component } from 'react';

import { Box } from '@mui/material';

export default class Empty extends Component {
  componentDidMount() {
    document.title = 'LeKinaSá | Not Found';
  }
  
  render() {
    return (
      <Box className='fill-screen center-flex'>
        <Box className='center-screen'>
          <p className='giant-text'>
            404
          </p>
          <p>
            This page doesn't exist.
          </p>
        </Box>
      </Box>
    );
  }
}
